module.exports = __webpack_public_path__ + "media/images/v2/dropdown_icon-786eef20b62bd8cf90072f12424335d4.png";